import { pipe } from 'fp-ts/function';
import { objectMap } from '../library/object';
const dimension = ['none', '3xs', 'xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', '3xl'];
const measureToString = (v) => typeof v.unit === 'undefined' ? `${v.value}` : `${v.value}${v.unit}`;
const isTokenMeasure = (a) => typeof a.value === 'number';
const isString = (a) => typeof a === 'string';
export const recursiveToString = (ts) => objectMap(ts, t => {
    if (isTokenMeasure(t)) {
        return measureToString(t);
    }
    if (isString(t)) {
        return t;
    }
    return recursiveToString(t);
});
const stringifyTokens = (tokens) => {
    const { space, grid, ...rts } = tokens;
    return {
        ...recursiveToString(rts),
        space: objectMap(space, s => measureToString({ value: tokens.grid * s.value, unit: 'px' })),
        grid: grid.toString(),
    };
};
export function makeVanillaTokens(tokens) {
    return pipe(tokens, stringifyTokens);
}
export function makeFabricsTheme(tokens, tokensClassName) {
    return {
        tokens,
        tokensClassName,
    };
}
